import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faTimes, faEdit, faEnvelope, faCoins, faCrown,
  faCheckCircle, faGem, faExclamationTriangle, faBan, faShoppingCart, faSpinner, faTimesCircle, faMobileAlt
} from '@fortawesome/free-solid-svg-icons';
import {
  Card, Form, Table, Pagination, Button, InputGroup, Dropdown,
  Spinner, Modal, Alert
} from '@themesberg/react-bootstrap';
import {
  collection, query, orderBy, onSnapshot, doc, getDoc, updateDoc,
  addDoc, serverTimestamp, where, getDocs, setDoc, limit, deleteDoc
} from 'firebase/firestore';
import axios from 'axios';
import { db } from '../../config/firebase';
import { Routes } from '../../routes';
import { resolveChatRoomId } from '../../utils/chatUtils';

export default () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchByEmail, setSearchByEmail] = useState(true);
  const [searchByPhone, setSearchByPhone] = useState(true);
  const [searchByName, setSearchByName] = useState(true);

  // Modal state'leri
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [showVerifiedModal, setShowVerifiedModal] = useState(false);
  const [showDiamondModal, setShowDiamondModal] = useState(false);
  const [showBanModal, setShowBanModal] = useState(false);
  const [showGoldModal, setShowGoldModal] = useState(false);
  const [showPurchaseBlockModal, setShowPurchaseBlockModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [targetMember, setTargetMember] = useState(null);
  const [creditsInput, setCreditsInput] = useState("");
  const [premiumDaysInput, setPremiumDaysInput] = useState("");
  const [modalError, setModalError] = useState(null);

  // Mesaj gönderme modal state'leri
  const [fakeAccounts, setFakeAccounts] = useState([]);
  const [filteredFakeAccounts, setFilteredFakeAccounts] = useState([]);
  const [selectedFakeAccountId, setSelectedFakeAccountId] = useState(null);
  const [fakeAccountSearch, setFakeAccountSearch] = useState("");
  const [messageText, setMessageText] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);

  // 1. Orijinal Gerçek Zamanlı Dinleyici (Varsayılan olarak çalışır: Son 100 Üye)
  useEffect(() => {
    // Eğer ARAMA yapılıyorsa, bu canlı dinleyiciyi hiç çalıştırma! (Sunucuyu yormayalım)
    if (searchTerm.trim() !== "") {
      return;
    }

    setLoading(true);

    // Tüm üyeleri dinlemek yerine, sadece "En Son Kayıt Olan 100 Kişiyi" canlı dinliyoruz.
    const q = query(
      collection(db, 'users'),
      orderBy('createdAt', 'desc'),
      hasValidFilters() ? where('isTestUser', '==', false) : limit(100)
      // Not: if compound query fails without composite index, we drop the where clause 
      // and handle it locally below just to be extremely safe against firestore index errors right now.
    );
    // Güvenli 100 limitli query
    const safeQ = query(
      collection(db, 'users'),
      orderBy('createdAt', 'desc'),
      limit(100)
    );

    const unsubscribe = onSnapshot(
      safeQ,
      (snapshot) => {
        try {
          const membersList = [];
          snapshot.forEach(doc => {
            const data = doc.data();
            // Test kullanıcılarını ve admin hesaplarını lokal olarak filtrele 
            // (Zaten sadece 100 veri iniyor, tarayıcıda filtrelemek 0.001 saniye sürer)
            if (data.isTestUser !== true && data.isAdmin !== true) {

              let age = data.age || 0;
              if (!age && data.birthDate) {
                const birthDate = data.birthDate.toDate ? data.birthDate.toDate() : new Date(data.birthDate);
                const today = new Date();
                age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                  age--;
                }
              }

              const fullName = data.name ||
                (data.firstName && data.lastName ? `${data.firstName} ${data.lastName}` :
                  data.firstName || data.lastName || '');

              const lastSeen = data.lastSeen;
              const now = Date.now();
              const activeThreshold = 5 * 60 * 1000;
              const lastSeenDate = lastSeen?.toDate ? lastSeen.toDate() : (lastSeen ? new Date(lastSeen) : null);
              const isOnline = lastSeenDate && (now - lastSeenDate.getTime() < activeThreshold);

              membersList.push({
                id: doc.id,
                name: fullName,
                email: data.email || '',
                phone: data.phoneNumber || data.phone || '',
                credit: data.credits || 0,
                online: isOnline,
                lastSeen: lastSeen || null,
                age: age,
                isBanned: data.isBanned || false,
                isApproved: data.isApproved || false,
                isDiamond: data.isDiamond || false,
                isGoldProfile: data.isGoldProfile || false,
                purchaseBlocked: data.purchaseBlocked || false,
                profileImageUrl: data.profileImageUrl || null,
                createdAt: data.createdAt || data.updatedAt || null
              });
            }
          });

          setMembers(membersList);
          setFilteredMembers(membersList); // Filtresiz olduğu için doğrudan ekle
          setError(null);
        } catch (err) {
          console.error("Error processing members:", err);
          setError("Üyeler işlenirken hata oluştu: " + err.message);
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        console.error("Error loading members:", err);
        setError("Üyeler yüklenirken hata oluştu: " + err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [searchTerm]); // searchTerm değiştiğinde çalışır

  // Yardımcı fonksiyon
  function hasValidFilters() {
    return false; // To bypass index errors
  }

  // Fake hesapları yükle (mesaj gönderme için)
  // ÖNEMLİ: where filtresi ile sadece fake hesapları çekiyoruz (15K tüm kullanıcı yerine ~50 fake hesap)
  useEffect(() => {
    const q = query(collection(db, 'users'), where('isTestUser', '==', true));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const accounts = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        accounts.push({
          id: doc.id,
          name: data.name || '',
          profileImageUrl: data.profileImageUrl || null
        });
      });
      accounts.sort((a, b) => a.name.localeCompare(b.name));
      setFakeAccounts(accounts);
      setFilteredFakeAccounts(accounts);
    });
    return () => unsubscribe();
  }, []);

  // Fake hesap arama
  useEffect(() => {
    if (!fakeAccountSearch.trim()) {
      setFilteredFakeAccounts(fakeAccounts);
      return;
    }
    const searchLower = fakeAccountSearch.toLowerCase().trim();
    const filtered = fakeAccounts.filter(account =>
      account.name.toLowerCase().includes(searchLower)
    ).sort((a, b) => a.name.localeCompare(b.name));
    setFilteredFakeAccounts(filtered);
  }, [fakeAccountSearch, fakeAccounts]);

  // 2. Arama Motoru İşlemi (Sunucu taraflı - Sadece arama butonuna basıldığında tetiklenmeli)
  // Mevcut sistem performansı çökerttiği için burayı değiştirdik. 
  // Artık sadece "Ara" butonuna basıldığında handleSearchFromFirebase çalışacak.
  // Yardımcı fonksiyon: Kelimelerin baş harflerini büyük yap (Title Case)
  // Örn: "ahmet deniz" → "Ahmet Deniz"
  const toTitleCase = (str) => {
    return str.replace(/\S+/g, (word) =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
  };

  const handleSearchFromFirebase = async () => {
    if (!searchTerm.trim()) {
      // Araştırma yoksa ilk 100 canlı üyeyi tekrar göster
      setFilteredMembers(members);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // 🚀 VPS PostgreSQL Search API (HTTPS) - 0.01 saniye!
      const response = await axios.get('https://216.126.227.107/api/admin/members', {
        params: {
          search: searchTerm,
          limit: 200 // Maksimum 200 arama sonucu getir
        },
        headers: {
          'x-admin-token': 'AdminEros2026!'
        }
      });

      if (response.data && response.data.success) {
        // VPS'ten gelen verileri yerel tablo formatına çevir
        const processedMembers = processRawDataToMembers(response.data.members);
        setFilteredMembers(processedMembers);
        setCurrentPage(1);
      } else {
        throw new Error("Sunucudan geçerli veri alınamadı.");
      }

    } catch (err) {
      console.error("Error during server search, falling back to Firestore:", err);
      try {
        const searchStr = searchTerm.trim();
        const titleCaseStr = toTitleCase(searchStr);
        let firestoreMembers = [];
        const userRef = collection(db, 'users');
        
        const queries = [];
        if (searchByName) {
           queries.push(getDocs(query(userRef, where('name', '>=', titleCaseStr), where('name', '<=', titleCaseStr + '\uf8ff'), limit(50))));
           queries.push(getDocs(query(userRef, where('firstName', '>=', titleCaseStr), where('firstName', '<=', titleCaseStr + '\uf8ff'), limit(50))));
        }
        if (searchByEmail) {
           queries.push(getDocs(query(userRef, where('email', '>=', searchStr.toLowerCase()), where('email', '<=', searchStr.toLowerCase() + '\uf8ff'), limit(50))));
        }
        if (searchByPhone) {
           // phone can be in different formats, but we try a basic prefix search
           queries.push(getDocs(query(userRef, where('phoneNumber', '>=', searchStr), where('phoneNumber', '<=', searchStr + '\uf8ff'), limit(50))));
        }
        
        const results = await Promise.allSettled(queries);
        const uniqueIds = new Set();
        
        results.forEach(res => {
           if (res.status === 'fulfilled') {
              res.value.forEach(docSnap => {
                 if (!uniqueIds.has(docSnap.id)) {
                    uniqueIds.add(docSnap.id);
                    firestoreMembers.push({ id: docSnap.id, ...docSnap.data() });
                 }
              });
           }
        });
        
        if (firestoreMembers.length === 0) {
           setFilteredMembers([]);
           setError("Kullanıcı bulunamadı.");
        } else {
           const processedMembers = processRawDataToMembers(firestoreMembers);
           setFilteredMembers(processedMembers);
           setCurrentPage(1);
           setError(null);
        }
      } catch (fallbackErr) {
        console.error("Firestore fallback error:", fallbackErr);
        setError("Arama sırasında hata oluştu. " + fallbackErr.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // Ham veriyi formata dönüştüren yardımcı fonksiyon
  const processRawDataToMembers = (rawList) => {
    const list = [];
    rawList.forEach(data => {
      if (data.isTestUser !== true && data.isAdmin !== true) {
        let age = data.age || 0;
        if (!age && data.birthDate) {
          const birthDate = data.birthDate.toDate ? data.birthDate.toDate() : new Date(data.birthDate);
          const today = new Date();
          age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
        }
        const fullName = data.name || (data.firstName && data.lastName ? `${data.firstName} ${data.lastName}` : data.firstName || data.lastName || '');
        const lastSeen = data.lastSeen;
        const now = Date.now();
        const activeThreshold = 5 * 60 * 1000;
        const lastSeenDate = lastSeen?.toDate ? lastSeen.toDate() : (lastSeen ? new Date(lastSeen) : null);
        const isOnline = lastSeenDate && (now - lastSeenDate.getTime() < activeThreshold);

        list.push({
          id: data.id,
          name: fullName,
          email: data.email || '',
          phone: data.phoneNumber || data.phone || '',
          credit: data.credits || 0,
          online: isOnline,
          lastSeen: lastSeen || null,
          age: age,
          isBanned: data.isBanned || false,
          isApproved: data.isApproved || false,
          isDiamond: data.isDiamond || false,
          isGoldProfile: data.isGoldProfile || false,
          purchaseBlocked: data.purchaseBlocked || false,
          profileImageUrl: data.profileImageUrl || null,
          createdAt: data.createdAt || data.updatedAt || null
        });
      }
    });

    list.sort((a, b) => {
      const timeA = a.createdAt?.toDate?.() || new Date(0);
      const timeB = b.createdAt?.toDate?.() || new Date(0);
      return timeB - timeA;
    });
    return list;
  };

  // Sayfalama hesaplamaları
  const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentMembers = filteredMembers.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  // Modal işlem fonksiyonları
  const handleUpdateCredits = async () => {
    if (!targetMember) return;

    try {
      const creditsChange = parseInt(creditsInput);
      if (isNaN(creditsChange)) {
        setModalError('Geçerli bir jeton değeri girin.');
        return;
      }

      const userRef = doc(db, 'users', targetMember.id);
      const userDoc = await getDoc(userRef);
      const currentCredits = userDoc.data()?.credits || 0;
      const newCredits = Math.max(0, currentCredits + creditsChange);

      await updateDoc(userRef, {
        credits: newCredits
      });

      // Listeyi güncelle
      setMembers(members.map(m =>
        m.id === targetMember.id ? { ...m, credit: newCredits } : m
      ));

      setShowCreditsModal(false);
      setCreditsInput("");
      setTargetMember(null);
      setModalError(null);
    } catch (err) {
      console.error('Error updating credits:', err);
      setModalError('Jeton güncellenirken bir hata oluştu.');
    }
  };

  const handleUpdatePremium = async () => {
    if (!targetMember) return;

    try {
      const days = parseInt(premiumDaysInput);
      if (isNaN(days) || days < 0) {
        setModalError('Geçerli bir gün sayısı girin.');
        return;
      }

      const userRef = doc(db, 'users', targetMember.id);
      let newExpiresAt = null;

      if (days > 0) {
        const now = new Date();
        const expiresAt = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
        newExpiresAt = expiresAt;
      }

      await updateDoc(userRef, {
        isPremium: days > 0,
        premiumExpiresAt: newExpiresAt
      });

      setShowPremiumModal(false);
      setPremiumDaysInput("");
      setTargetMember(null);
      setModalError(null);

      // Listeyi yeniden yükle
      window.location.reload();
    } catch (err) {
      console.error('Error updating premium:', err);
      setModalError('Premium durumu güncellenirken bir hata oluştu.');
    }
  };

  const handleSetVerified = async () => {
    if (!targetMember) return;

    try {
      const userRef = doc(db, 'users', targetMember.id);
      const newStatus = !targetMember.isApproved;
      await updateDoc(userRef, {
        isApproved: newStatus
      });

      setShowVerifiedModal(false);
      setTargetMember(null);

      // Listeyi güncelle
      setMembers(members.map(m =>
        m.id === targetMember.id ? { ...m, isApproved: newStatus } : m
      ));
    } catch (err) {
      console.error('Error setting verified:', err);
      setModalError('Doğrulanmış profil durumu güncellenirken bir hata oluştu.');
    }
  };

  const handleSetDiamond = async () => {
    if (!targetMember) return;

    try {
      const userRef = doc(db, 'users', targetMember.id);
      const newStatus = !targetMember.isDiamond;
      await updateDoc(userRef, {
        isDiamond: newStatus
      });

      setShowDiamondModal(false);
      setTargetMember(null);

      // Listeyi güncelle
      setMembers(members.map(m =>
        m.id === targetMember.id ? { ...m, isDiamond: newStatus } : m
      ));
    } catch (err) {
      console.error('Error setting diamond:', err);
      setModalError('Diamond üye durumu güncellenirken bir hata oluştu.');
    }
  };

  const handleSetGold = async () => {
    if (!targetMember) return;

    try {
      const userRef = doc(db, 'users', targetMember.id);
      const newStatus = !targetMember.isGoldProfile;
      await updateDoc(userRef, {
        isGoldProfile: newStatus
      });

      setShowGoldModal(false);
      setTargetMember(null);

      // Listeyi güncelle
      setMembers(members.map(m =>
        m.id === targetMember.id ? { ...m, isGoldProfile: newStatus } : m
      ));
    } catch (err) {
      console.error('Error setting gold:', err);
      setModalError('Gold profil durumu güncellenirken bir hata oluştu.');
    }
  };

  const handleBanUser = async () => {
    if (!targetMember) return;

    try {
      const userRef = doc(db, 'users', targetMember.id);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();
      const newStatus = !targetMember.isBanned;

      await updateDoc(userRef, {
        isBanned: newStatus
      });

      // Cihaz banı - deviceId varsa bannedDevices koleksiyonuna ekle/çıkar
      const deviceId = userData?.deviceId;
      const hardwareId = userData?.hardwareId;
      if (deviceId) {
        const bannedDeviceRef = doc(db, 'bannedDevices', deviceId);
        if (newStatus) {
          await setDoc(bannedDeviceRef, {
            isBanned: true,
            bannedAt: serverTimestamp(),
            deviceId: deviceId,
            hardwareId: hardwareId || null,
            userId: targetMember.id,
            reason: 'Admin panelden banlandı'
          });
          // hardwareId de varsa ayrıca onu da banla
          if (hardwareId) {
            await setDoc(doc(db, 'bannedDevices', hardwareId), {
              isBanned: true,
              bannedAt: serverTimestamp(),
              deviceId: hardwareId,
              hardwareId: hardwareId,
              linkedPrimaryId: deviceId,
              userId: targetMember.id,
              type: 'hardware_ban',
              reason: 'Admin panelden banlandı'
            });
          }
          console.log(`Device banned: ${deviceId}, hardware: ${hardwareId} for user: ${targetMember.id}`);
        } else {
          await deleteDoc(bannedDeviceRef);
          if (hardwareId) {
            try { await deleteDoc(doc(db, 'bannedDevices', hardwareId)); } catch (e) { }
          }
          console.log(`Device unbanned: ${deviceId} for user: ${targetMember.id}`);
        }
      } else {
        console.warn(`No deviceId found for user ${targetMember.id}. User ban applied but device ban skipped.`);
      }

      setShowBanModal(false);
      setTargetMember(null);

      // Listeyi güncelle
      setMembers(members.map(m =>
        m.id === targetMember.id ? { ...m, isBanned: newStatus } : m
      ));
    } catch (err) {
      console.error('Error banning user:', err);
      setModalError('Kullanıcı ban durumu güncellenirken bir hata oluştu.');
    }
  };

  // Cihaz banı - sadece cihazı banla (kalıcı)
  const handleDeviceBan = async (member) => {
    if (!member) return;
    if (!window.confirm(
      `"${member.name}" kullanıcısının CİHAZINI banlamak istediğinize emin misiniz?\n\n` +
      `Bu işlem:\n` +
      `• Cihazı kalıcı olarak banlar\n` +
      `• Uygulama silip yüklese bile ban devam eder\n` +
      `• Yeni hesap açsa bile giriş yapamaz`
    )) return;

    try {
      const userRef = doc(db, 'users', member.id);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();
      const deviceId = userData?.deviceId;
      const hardwareId = userData?.hardwareId;

      if (!deviceId) {
        alert('Bu kullanıcının cihaz bilgisi bulunamadı. Kullanıcı uygulamayı henüz açmamış olabilir.');
        return;
      }

      // deviceId'yi bannedDevices'a ekle
      await setDoc(doc(db, 'bannedDevices', deviceId), {
        isBanned: true,
        bannedAt: serverTimestamp(),
        deviceId: deviceId,
        hardwareId: hardwareId || null,
        userId: member.id,
        reason: 'Cihaz banı (Admin Panel)'
      });

      // hardwareId varsa onu da banla
      if (hardwareId) {
        await setDoc(doc(db, 'bannedDevices', hardwareId), {
          isBanned: true,
          bannedAt: serverTimestamp(),
          deviceId: hardwareId,
          hardwareId: hardwareId,
          linkedPrimaryId: deviceId,
          userId: member.id,
          type: 'hardware_ban',
          reason: 'Cihaz banı (Admin Panel)'
        });
      }

      // Kullanıcıyı da banla
      await updateDoc(userRef, { isBanned: true });

      // Listeyi güncelle
      setMembers(members.map(m =>
        m.id === member.id ? { ...m, isBanned: true } : m
      ));

      alert(`Cihaz başarıyla banlandı!\nDevice ID: ${deviceId.substring(0, 16)}...\n${hardwareId ? 'Hardware ID: ' + hardwareId.substring(0, 16) + '...' : ''}\nBu cihaz artık uygulamayı açamaz.`);
    } catch (err) {
      console.error('Error device banning user:', err);
      alert('Cihaz banı sırasında hata: ' + err.message);
    }
  };

  const handleTogglePurchaseBlock = async () => {
    if (!targetMember) return;

    try {
      const userRef = doc(db, 'users', targetMember.id);
      const newStatus = !targetMember.purchaseBlocked;
      await updateDoc(userRef, {
        purchaseBlocked: newStatus
      });

      setShowPurchaseBlockModal(false);
      setTargetMember(null);

      setMembers(members.map(m =>
        m.id === targetMember.id ? { ...m, purchaseBlocked: newStatus } : m
      ));
    } catch (err) {
      console.error('Error toggling purchase block:', err);
      setModalError('Satın alma engeli güncellenirken bir hata oluştu.');
    }
  };

  const handleSendMessage = async (navigateToChat = false) => {
    if (!targetMember || !selectedFakeAccountId || !messageText.trim()) {
      setModalError('Lütfen fake hesap seçin ve mesaj yazın.');
      return;
    }

    try {
      setSendingMessage(true);
      setModalError(null);

      // Chat room oluştur veya bul
      const fakeAccountId = selectedFakeAccountId;
      const userId = targetMember.id;
      const roomId = await resolveChatRoomId(fakeAccountId, userId);

      const roomRef = doc(db, 'chatRooms', roomId);
      const roomDoc = await getDoc(roomRef);

      if (!roomDoc.exists()) {
        await setDoc(roomRef, {
          participantUids: [fakeAccountId, userId],
          lastMessage: messageText.trim(),
          lastMessageAt: serverTimestamp(),
          lastMessageType: 'text',
          lastMessageSenderId: fakeAccountId,
          createdAt: serverTimestamp()
        });
      } else {
        await updateDoc(roomRef, {
          lastMessage: messageText.trim(),
          lastMessageAt: serverTimestamp(),
          lastMessageType: 'text',
          lastMessageSenderId: fakeAccountId,
          ignoredAt: null
        });
      }

      // Mesaj gönder
      const messagesRef = collection(db, 'chatRooms', roomId, 'messages');
      await addDoc(messagesRef, {
        senderId: fakeAccountId,
        receiverId: userId,
        message: messageText.trim(),
        timestamp: serverTimestamp(),
        type: 'text'
      });

      setShowMessageModal(false);
      setMessageText("");
      setSelectedFakeAccountId(null);
      setTargetMember(null);

      if (navigateToChat) {
        history.push(`/messages/reply/${roomId}?receiverId=${fakeAccountId}&senderId=${userId}`);
      }
    } catch (err) {
      console.error('Error sending message:', err);
      setModalError('Mesaj gönderilirken bir hata oluştu: ' + err.message);
    } finally {
      setSendingMessage(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <div className="py-4">
        <h4>Listele</h4>
        <p className="text-muted mb-0">Üyeler / Listele</p>
      </div>

      <div className="mb-4">
        <InputGroup>
          <Form.Control
            type="text"
            placeholder="Ara... (İsim, E-posta, Telefon)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearchFromFirebase();
              }
            }}
          />
          <Button variant="primary" onClick={handleSearchFromFirebase}>Ara</Button>
        </InputGroup>
        <div className="mt-2 d-flex gap-3">
          <Form.Check
            type="checkbox"
            label="İsim-Soyad"
            checked={searchByName}
            onChange={(e) => setSearchByName(e.target.checked)}
          />
          <Form.Check
            type="checkbox"
            label="E-posta"
            checked={searchByEmail}
            onChange={(e) => setSearchByEmail(e.target.checked)}
          />
          <Form.Check
            type="checkbox"
            label="Telefon"
            checked={searchByPhone}
            onChange={(e) => setSearchByPhone(e.target.checked)}
          />
        </div>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.85rem' }}>
              <thead>
                <tr>
                  <th style={{ width: '40px' }}>#</th>
                  <th style={{ width: '80px' }}>Resim</th>
                  <th>Kredi</th>
                  <th>Online</th>
                  <th>Son Görülme</th>
                  <th>Ad Soyad</th>
                  <th>Yaş</th>
                  <th>E-posta</th>
                  <th>Telefon Numarası</th>
                  <th>Ban Durumu</th>
                  <th>Doğrulanma Durumu</th>
                  <th style={{ width: '280px' }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {currentMembers.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center py-4">
                      {searchTerm ? 'Arama sonucu bulunamadı.' : 'Henüz üye bulunmamaktadır.'}
                    </td>
                  </tr>
                ) : (
                  currentMembers.map((member, index) => (
                    <tr key={member.id}>
                      <td className="text-center">{startIndex + index + 1}</td>
                      <td>
                        {member.profileImageUrl ? (
                          <img
                            src={member.profileImageUrl}
                            alt={member.name}
                            className="rounded-circle"
                            style={{ width: 40, height: 40, objectFit: 'cover' }}
                          />
                        ) : (
                          <div
                            className="rounded-circle bg-secondary d-flex align-items-center justify-content-center"
                            style={{
                              width: 40,
                              height: 40
                            }}
                          >
                            <span style={{ fontSize: '0.8rem', color: '#fff' }}>
                              {member.name ? member.name.charAt(0).toUpperCase() : '?'}
                            </span>
                          </div>
                        )}
                      </td>
                      <td>{member.credit}</td>
                      <td>
                        {member.online ? (
                          <FontAwesomeIcon icon={faCheck} className="text-success" />
                        ) : (
                          <FontAwesomeIcon icon={faTimes} className="text-danger" />
                        )}
                      </td>
                      <td>
                        <small>
                          {member.lastSeen ? (
                            member.lastSeen.toDate ? member.lastSeen.toDate().toLocaleString('tr-TR') : new Date(member.lastSeen).toLocaleString('tr-TR')
                          ) : "-"}
                        </small>
                      </td>
                      <td>
                        <strong>{member.name || "-"}</strong>
                      </td>
                      <td>{member.age || "-"}</td>
                      <td>
                        <small>{member.email || "-"}</small>
                      </td>
                      <td>
                        <small>{member.phone || "-"}</small>
                      </td>
                      <td>
                        {member.isBanned ? (
                          <FontAwesomeIcon icon={faCheck} className="text-success" title="Banlı" />
                        ) : (
                          <FontAwesomeIcon icon={faTimes} className="text-danger" title="Banlı Değil" />
                        )}
                      </td>
                      <td>
                        {member.isApproved ? (
                          <FontAwesomeIcon icon={faCheck} className="text-success" title="Doğrulanmış" />
                        ) : (
                          <FontAwesomeIcon icon={faTimes} className="text-danger" title="Doğrulanmamış" />
                        )}
                      </td>
                      <td>
                        <div className="d-flex gap-1 flex-wrap">
                          <Button
                            variant="primary"
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title="Düzenle"
                            onClick={() => history.push(`/members/edit/${member.id}`)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                          <Button
                            variant={member.isGoldProfile ? "warning" : "outline-warning"}
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title={member.isGoldProfile ? "Gold'dan Çıkar" : "Gold Yap"}
                            onClick={() => {
                              setTargetMember(member);
                              setShowGoldModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCrown} />
                          </Button>
                          <Button
                            variant="info"
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title="Mesaj Gönder"
                            onClick={() => {
                              setTargetMember(member);
                              setShowMessageModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faEnvelope} />
                          </Button>
                          <Button
                            variant="warning"
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title="Jeton Ekle/Sil"
                            onClick={() => {
                              setTargetMember(member);
                              setCreditsInput("");
                              setShowCreditsModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCoins} />
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title="Premium Ekle"
                            onClick={() => {
                              setTargetMember(member);
                              setPremiumDaysInput("");
                              setShowPremiumModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCrown} />
                          </Button>
                          <Button
                            variant={member.isApproved ? "danger" : "success"}
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title={member.isApproved ? "Onay Kaldır" : "Doğrulanmış Profil Yap"}
                            onClick={() => {
                              setTargetMember(member);
                              setShowVerifiedModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={member.isApproved ? faTimes : faCheckCircle} />
                          </Button>
                          <Button
                            variant={member.isDiamond ? "danger" : "primary"}
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title={member.isDiamond ? "Diamond Kaldır" : "Diamond Üye Yap"}
                            onClick={() => {
                              setTargetMember(member);
                              setShowDiamondModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faGem} />
                          </Button>
                          <Button
                            variant={member.isBanned ? "success" : "danger"}
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title={member.isBanned ? "Ban Kaldır" : "Banla"}
                            onClick={() => {
                              setTargetMember(member);
                              setShowBanModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={member.isBanned ? faCheck : faBan} />
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title="Cihaz Banla (Kalıcı)"
                            onClick={() => handleDeviceBan(member)}
                          >
                            <FontAwesomeIcon icon={faMobileAlt} />
                          </Button>
                          <Button
                            variant={member.purchaseBlocked ? "warning" : "outline-warning"}
                            size="sm"
                            className="p-1"
                            style={{ width: '32px', height: '32px' }}
                            title={member.purchaseBlocked ? "Satın Alma Engeli Kaldır" : "Satın Almayı Engelle"}
                            onClick={() => {
                              setTargetMember(member);
                              setShowPurchaseBlockModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faShoppingCart} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          {/* Sayfalama */}
          {filteredMembers.length > 0 && (
            <div className="d-flex justify-content-between align-items-center p-3 bg-dark">
              <div className="d-flex align-items-center gap-2">
                <span className="text-white">Gösterilecek satır sayısı:</span>
                <Dropdown>
                  <Dropdown.Toggle variant="secondary" size="sm" id="dropdown-items-per-page">
                    {itemsPerPage}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleItemsPerPageChange(10)}>10</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleItemsPerPageChange(20)}>20</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleItemsPerPageChange(30)}>30</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleItemsPerPageChange(50)}>50</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <span className="text-white">
                  {startIndex + 1} - {Math.min(endIndex, filteredMembers.length)} / {filteredMembers.length}
                </span>
              </div>
              <Pagination className="mb-0" size="sm">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />
                {(() => {
                  const pages = [];
                  const maxVisible = 5;
                  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                  let endPage = Math.min(totalPages, startPage + maxVisible - 1);

                  if (endPage - startPage < maxVisible - 1) {
                    startPage = Math.max(1, endPage - maxVisible + 1);
                  }

                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" />);
                    }
                  }

                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item
                        key={i}
                        active={i === currentPage}
                        onClick={() => handlePageChange(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }

                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" />);
                    }
                    pages.push(
                      <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
                        {totalPages}
                      </Pagination.Item>
                    );
                  }

                  return pages;
                })()}
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
                <Pagination.Last
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Modals */}
      <Modal show={showCreditsModal} onHide={() => {
        setShowCreditsModal(false);
        setModalError(null);
        setCreditsInput("");
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Jeton Ekle/Sil - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          <Form.Group>
            <Form.Label>
              Jeton Değişikliği (Mevcut: {targetMember?.credit || 0})
              <br />
              <small className="text-muted">Pozitif değer ekler, negatif değer çıkarır</small>
            </Form.Label>
            <Form.Control
              type="number"
              value={creditsInput}
              onChange={(e) => setCreditsInput(e.target.value)}
              placeholder="Örn: 100 veya -50"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleUpdateCredits();
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowPremiumModal(false);
            setModalError(null);
            setPremiumDaysInput("");
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleUpdatePremium}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showGoldModal} onHide={() => {
        setShowGoldModal(false);
        setModalError(null);
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{targetMember?.isGoldProfile ? "Gold Profilden Çıkar" : "Gold Profil Yap"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          <p>
            <strong>{targetMember?.name}</strong> isimli kullanıcıyı {targetMember?.isGoldProfile ? "Gold profil statüsünden çıkarmak" : "Gold profil yapmak"} istediğinizden emin misiniz?
          </p>
          {!targetMember?.isGoldProfile && (
            <Alert variant="info">
              Gold profillerin biyografilerini görmek için kullanıcılar 300 jeton ödemek zorundadır.
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowGoldModal(false);
            setModalError(null);
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant="warning" onClick={handleSetGold}>
            {targetMember?.isGoldProfile ? "Evet, Çıkar" : "Evet, Gold Yap"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPremiumModal} onHide={() => {
        setShowPremiumModal(false);
        setModalError(null);
        setPremiumDaysInput("");
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Premium Ekle - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          <Form.Group>
            <Form.Label>Premium Gün Sayısı (0 = Premium'u Kaldır)</Form.Label>
            <Form.Control
              type="number"
              value={premiumDaysInput}
              onChange={(e) => setPremiumDaysInput(e.target.value)}
              placeholder="10"
              min="0"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleUpdatePremium();
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowPremiumModal(false);
            setModalError(null);
            setPremiumDaysInput("");
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleUpdatePremium}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showVerifiedModal} onHide={() => {
        setShowVerifiedModal(false);
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{targetMember?.isApproved ? "Onay Kaldır" : "Doğrulanmış Profil Yap"} - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu üyenin {targetMember?.isApproved ? "doğrulanmış profil onayını kaldırmak" : "profilini doğrulamak"} istediğinizden emin misiniz?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowVerifiedModal(false);
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant={targetMember?.isApproved ? "danger" : "success"} onClick={handleSetVerified}>
            {targetMember?.isApproved ? "Evet, Onay Kaldır" : "Evet, Doğrula"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDiamondModal} onHide={() => {
        setShowDiamondModal(false);
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{targetMember?.isDiamond ? "Diamond Üyeliği Kaldır" : "Diamond Üye Yap"} - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu üyenin {targetMember?.isDiamond ? "Diamond üyeliğini kaldırmak" : "Diamond üye yapmak"} istediğinizden emin misiniz?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowDiamondModal(false);
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant={targetMember?.isDiamond ? "danger" : "primary"} onClick={handleSetDiamond}>
            {targetMember?.isDiamond ? "Evet, Diamond Kaldır" : "Evet, Diamond Yap"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBanModal} onHide={() => {
        setShowBanModal(false);
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{targetMember?.isBanned ? "Banı Kaldır" : "Kullanıcıyı Banla"} - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {targetMember?.isBanned ?
            "Bu kullanıcının banını kaldırmak istediğinizden emin misiniz?" :
            "Bu kullanıcıyı banlamak istediğinizden emin misiniz? Banlanan kullanıcılar hiçbir üyeye mesaj atamaz ve hiçbir canlı yayına katılamaz."
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowBanModal(false);
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant={targetMember?.isBanned ? "success" : "danger"} onClick={handleBanUser}>
            {targetMember?.isBanned ? "Evet, Banı Kaldır" : "Evet, Banla"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPurchaseBlockModal} onHide={() => {
        setShowPurchaseBlockModal(false);
        setTargetMember(null);
      }}>
        <Modal.Header closeButton>
          <Modal.Title>{targetMember?.purchaseBlocked ? "Satın Alma Engelini Kaldır" : "Satın Almayı Engelle"} - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {targetMember?.purchaseBlocked ?
            "Bu kullanıcının satın alma engelini kaldırmak istediğinizden emin misiniz? Kullanıcı tekrar satın alma yapabilecek." :
            "Bu kullanıcının satın alma işlemini engellemek istediğinizden emin misiniz? Kullanıcı hiçbir jeton veya VIP paketi satın alamayacak."
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowPurchaseBlockModal(false);
            setTargetMember(null);
          }}>
            İptal
          </Button>
          <Button variant={targetMember?.purchaseBlocked ? "success" : "warning"} onClick={handleTogglePurchaseBlock}>
            {targetMember?.purchaseBlocked ? "Evet, Engeli Kaldır" : "Evet, Engelle"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showMessageModal} onHide={() => {
        setShowMessageModal(false);
        setMessageText("");
        setSelectedFakeAccountId(null);
        setFakeAccountSearch("");
        setTargetMember(null);
        setModalError(null);
      }} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Mesaj Gönder - {targetMember?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalError && <Alert variant="danger">{modalError}</Alert>}
          <Form.Group className="mb-3">
            <Form.Label>Mesajı Gönderen Kişi</Form.Label>
            <Form.Label className="text-muted d-block">Hesap Seçin</Form.Label>
            <Form.Control
              type="text"
              placeholder="Fake hesap ara..."
              value={fakeAccountSearch}
              onChange={(e) => setFakeAccountSearch(e.target.value)}
              className="mb-2"
            />
            <Form.Select
              value={selectedFakeAccountId || ""}
              onChange={(e) => setSelectedFakeAccountId(e.target.value)}
            >
              <option value="">Fake hesap seçin...</option>
              {filteredFakeAccounts.map(account => (
                <option key={account.id} value={account.id}>
                  {account.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>Mesaj</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Mesaj..."
              value={messageText}
              onChange={(e) => setMessageText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSendMessage(false);
                }
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowMessageModal(false);
            setMessageText("");
            setSelectedFakeAccountId(null);
            setFakeAccountSearch("");
            setTargetMember(null);
            setModalError(null);
          }}>
            İptal
          </Button>
          <Button
            variant="primary"
            onClick={() => handleSendMessage(false)}
            disabled={sendingMessage || !selectedFakeAccountId || !messageText.trim()}
          >
            {sendingMessage ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Gönderiliyor...
              </>
            ) : (
              'Gönder'
            )}
          </Button>
          <Button
            variant="info"
            onClick={() => handleSendMessage(true)}
            disabled={sendingMessage || !selectedFakeAccountId || !messageText.trim()}
          >
            {sendingMessage ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Gönderiliyor...
              </>
            ) : (
              "Gönder ve Chat'e git"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
